export default class ProcessadorMapeamento {
    constructor({ servicoDatahub }) {
        this.servicoDataHub = servicoDatahub;
    }

    interpolarValor({ operando, dados, atribuicoes }) {
        return operando.chave.replace(
            /(\$)\$\{([\w\s]+)\}|\$\{([\w\s]+)\}/g,
            (match, esc, chaveEsc, chave) => {
                // Se for escapado com $$, retornamos apenas ${chave} sem substituição
                if (esc === "$") {
                    return `\${${chaveEsc}}`;
                }
                if (chave in dados) {
                    return dados[chave];
                } else if (chave in atribuicoes) {
                    return atribuicoes[chave];
                } else {
                    return match;
                }
            }
        );
    }

    async calcularValor({ operando, dados, atribuicoes }) {
        const chaveInterpolada = this.interpolarValor({
            operando,
            dados,
            atribuicoes,
        });
        return await this.servicoDataHub.obterMapeamento({
            mapa: operando.mapa,
            chave: chaveInterpolada,
        });
    }
}
